import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/logo";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  DrawerClose,
} from "@/components/ui/drawer";
import { BuyerSidebar } from "./BuyerSidebar";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function BuyerMobileHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Auto-close drawer when route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleLogoClick = () => {
    navigate('/buyer/dashboard');
  };

  return (
    <header className="sticky top-0 z-40 border-b bg-card md:hidden">
      <div className="flex h-16 items-center justify-between px-4">
        <Drawer open={open} onOpenChange={setOpen}>
          <DrawerTrigger asChild>
            <Button variant="ghost" size="icon" aria-label="Open menu" className="size-11 min-h-[44px] min-w-[44px]">
              <Menu className="size-5" />
            </Button>
          </DrawerTrigger>
          <DrawerContent className="pb-safe max-h-[85vh] pt-2">
            <DrawerHeader className="relative px-4 pb-3">
              <DrawerTitle className="text-lg">Menu</DrawerTitle>
              <DrawerClose asChild>
                <Button variant="ghost" size="icon" className="absolute right-4 top-3 size-10 min-h-[44px] min-w-[44px]" aria-label="Close menu">
                  <X className="size-5" />
                </Button>
              </DrawerClose>
            </DrawerHeader>
              <div className="overflow-y-auto px-2">
                <BuyerSidebar variant="drawer" onNavigate={() => setOpen(false)} />
            </div>
          </DrawerContent>
        </Drawer>
        
        <div 
          className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 px-2 py-1" 
          onClick={handleLogoClick}
        >
          <Logo variant="dark" width={115} />
          <p className="text-xs text-muted-foreground">Buyer Portal</p>
        </div>
        
        <div className="w-10" /> {/* Spacer for center alignment */}
      </div>
    </header>
  );
}
